import { IBankAccountCredentials } from '@commenda/types';
import { fetcher } from '@commenda/utils';
import { BankAccountType, Country } from '@prisma/client';

export interface UpdateBankAccountParams {
  accountHolderName?: string;
  bankName?: string;
  country?: Country;
  currency?: string;
  credentials?: Partial<IBankAccountCredentials>;
  subType?: BankAccountType;
}

export async function updateBankAccount(
  bankAccountId: string,
  data: UpdateBankAccountParams
): Promise<{ success: boolean }> {
  const res = await fetcher(`bankAccount/${bankAccountId}`, {
    method: 'POST',
    body: data,
  });
  return { success: res.ok };
}
